import React from 'react';
import { Field } from '@progress/kendo-react-form';
import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { FormDropDownList } from './FormDropdown';
import { requiredValidator } from '../validators/FormValidator';
import { CONTENT_TYPE_FIELD, NEW_DOCUMENT } from '@cs-cms/types';
import { useGlobalizationContext, useTranslation } from '@cs-cms/state-management';

interface FormContentTypeFieldProps {
  ctsWithCreatePermissions: string[] | undefined;
  editedDocument: any;
  onContentTypeChange: (contentTypeName: string, formRenderProps: any) => void;
  formRenderProps: any;
}

export const FormContentTypeField: React.FC<FormContentTypeFieldProps> = ({
  ctsWithCreatePermissions,
  editedDocument,
  onContentTypeChange,
  formRenderProps
}) => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  const handleChange = (event: DropDownListChangeEvent) => {
    const value = event.value;
    formRenderProps.onFormReset();
    formRenderProps.onChange(CONTENT_TYPE_FIELD, { value });
    onContentTypeChange(value.id, formRenderProps);
  };

  return (
    <Field
      name={CONTENT_TYPE_FIELD}
      component={FormDropDownList}
      data={ctsWithCreatePermissions?.map(item => ({ id: item, name: item })) || []}
      textField={'name'}
      dataItemKey={'id'}
      label={translate('custom.toolbar.actions.form.contentType')}
      optional={false}
      validator={requiredValidator}
      onChange={handleChange}
      disabled={editedDocument !== NEW_DOCUMENT}
      className="ctDropdown"
    />
  );
};
